import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';

const borte = 'h1-borte';
const hjemme = 'h2-hjemme';

const dValg: RadioButtonValgModel<VeilederVgsUrDto>[] = [
    { id: 'h1', value: borte, tekst: 'valgBorForMegSelv' },
    {
        id: 'h2',
        value: hjemme,
        tekst: 'valgBorMedForeldre',
    },
];

export default {
    h1_hjemme: hjemme,
    h2_borte: borte,
    hValg: dValg,
};
